import routeMatcher from './routeMatcher';

export default function getRouteInfo(href: any): boolean {
  return routeMatcher(href);
}
